import React from 'react';
import { IconProps } from '../types';

export const FashionIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1842 0.333374H13.816L14.7256 1.47771C15.0307 1.86164 15.4718 2.1136 15.9575 2.1815C18.0216 2.47002 19.139 4.75443 18.0998 6.56097L16.9287 8.59694C16.389 9.53519 16.501 10.7121 17.2082 11.5316L17.6584 12.0533C18.954 13.5549 19.6667 15.472 19.6667 17.4552V18.4552H19.4283C19.0632 19.1741 18.3168 19.6667 17.4553 19.6667H7.79641C6.62023 19.6667 5.66675 18.7132 5.66675 17.537V16.537H5.73127C5.94886 14.8584 6.71009 13.2863 7.91277 12.0695L8.53346 11.4415C9.30999 10.6558 9.47093 9.45024 8.92769 8.48838L7.78222 6.4602C6.78509 4.69467 7.88113 2.47962 9.88959 2.20131L10.0263 2.18236C10.5227 2.11357 10.9736 1.85634 11.2855 1.46401L12.1842 0.333374ZM7.66675 17.537C7.66675 17.6087 7.7248 17.6667 7.79641 17.6667H17.4553C17.5721 17.6667 17.6667 17.572 17.6667 17.4552C17.6667 15.9517 17.1264 14.4982 16.1441 13.3599L15.6939 12.8381C14.4317 11.3753 14.2316 9.27451 15.195 7.59969L16.3662 5.56371C16.6988 4.98561 16.3412 4.25457 15.6806 4.16224L14.6903 4.0238L14.7083 3.89509C14.1066 3.64256 13.5726 3.24134 13.1599 2.72219L13.0001 2.52111L12.8511 2.7085C12.2195 3.50311 11.3063 4.02411 10.3008 4.16343L10.1641 4.18238C9.55373 4.26696 9.22064 4.94012 9.52367 5.47666L10.6691 7.50484C11.6519 9.24499 11.3608 11.426 9.95592 12.8474L9.33523 13.4754C8.26625 14.557 7.66675 16.0163 7.66675 17.537Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0001 18.6667V26.6667H12.0001L12.0001 18.6667H14.0001Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.66675 29.3334C5.66675 27.3083 7.30837 25.6667 9.33341 25.6667H16.0001C18.0251 25.6667 19.6667 27.3083 19.6667 29.3334V31.6667H5.66675V29.3334ZM9.33341 27.6667C8.41294 27.6667 7.66675 28.4129 7.66675 29.3334V29.6667H17.6667V29.3334C17.6667 28.4129 16.9206 27.6667 16.0001 27.6667H9.33341Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.3334 2.66671V6.83337H25.3334V2.66671L27.3334 2.66671ZM27.3334 9.16671V15.5H25.3334V9.16671H27.3334ZM27.3334 17.8334V24.1667H25.3334V17.8334H27.3334ZM27.3334 26.5L27.3334 30.6667H25.3334V26.5H27.3334Z"
            fill={color}
        />
    </svg>
);
